<app-voucher-titulo></app-voucher-titulo>
<app-spinner *ngIf="vouchersInvalidos === undefined"></app-spinner>
<div *ngIf="vouchersInvalidos !== undefined">
  <div class="col-xs-12 col-md-6 col-md-offset-3">
    <div class="panel panel-default">
      <div class="panel-heading">
        <h3 class="panel-title"><b>Voucher principal para resgate:</b></h3>
      </div>

      <div class="panel-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th>Número do Voucher</th>
                <th>Pontos</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td> {{ voucherService?.voucherPrincipal?.getNumero() }} </td>
                <td>{{ voucherService?.voucherPrincipal?.getSaldoPontos() }}</td>
                <td>
                  <button (click)="irParaTelaVoucherConfirmar()" type="button" class="btn btn-warning">
                    <i class="fa fa-pencil"></i> alterar
                  </button>
                </td>
              </tr>
              <tr *ngIf="isVoucherInvalido(voucherService?.voucherPrincipal)" class="alert alert-danger"
                role="alert">
                <td colspan="3">
                  {{getMensagemInconsistencia(voucherService?.voucherPrincipal)}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>

  <app-voucher-lista-adicionais *ngIf="voucherService?.vouchersAdicionais?.length > 0"></app-voucher-lista-adicionais>

  <div class="col-xs-12 col-md-6 col-md-offset-3" style="margin-top: 2em;">
    <div class="form-group">
      <label for="valorBruto">Total em pontos para resgate</label>
      <input type="text" class="form-control input-lg" id="valorBruto" name="valorBruto"
        [ngModel]="getValorTotalPontos()" readonly>
    </div>
    <div class="form-group">
      <label for="tarifa">Tarifa DOC/TED em pontos</label>
      <input type="text" class="form-control input-lg" id="tarifa" [ngModel]="pontosTarifa" name="pontosTarifa"
        readonly>
    </div>
    <div class="form-group">
      <label for="valorLiquido">Valor liquido da transferência</label>
      <input type="text" class="form-control input-lg" id="valorLiquido"
        [ngModel]="getValorLiquido() | currency:'BRL':'symbol':'1.2-2':'pt'" readonly>
    </div>
    <div class="col-xs-12 col-md-8 col-md-offset-2">
      <button type="button" class="col-xs-12 btn app-btn-best" style="margin-bottom: 0.5em;" data-toggle="modal"
        data-target="#voucher" (click)="abrirModalAdicionarVoucher()">
        Tenho mais Vouchers para resgate...
      </button>
      <button type="button" class="col-xs-12 btn btn-warning" style="margin-bottom: 4.5em;" (click)="validarVouchers()">
        Continuar resgate
      </button>
    </div>
  </div>
</div>

<div class="modal fade" id="voucher" tabindex="-1" role="dialog" aria-labelledby="voucherLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form (submit)="inserirVoucherAdicional($event)" ngNativeValidate>
        <div class="modal-header">
          <h4 class="modal-title" id="voucherLabel">Adicionar Voucher</h4>
        </div>
        <div class="modal-body">
          <p class="bg-info">Aqui você pode informar os dados de outro Voucher para resgate na mesma transferência
            bancária, pagando apenas uma tarifa de DOC/TED!</p>
          <div class="form-group">
            <label for="numero">Número do Voucher</label>
            <input type="text" class="form-control" id="numero" name="voucher.numero"
              [ngModel]="voucherAdicional?.getNumero()" (ngModelChange)="voucherAdicional?.setNumero($event)" UiCartao
              required>
          </div>
          <div class="form-group">
            <label for="saldoPontos">Pontos do Voucher</label>
            <input type="text" class="form-control" id="saldoPontos" name="voucher.saldoPontos"
              [ngModel]="voucherAdicional?.getSaldoPontos()" (ngModelChange)="voucherAdicional?.setSaldoPontos($event)"
              UiPontos required>
          </div>
          <div class="form-group">
            <label for="senha">Senha do Voucher</label>
            <input type="password" class="form-control" id="senha" name="voucher.senha"
              [ngModel]="voucherAdicional?.getSenha()" (ngModelChange)="voucherAdicional?.setSenha($event)" required>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" id="btn-modal-fechar">Cancelar</button>
          <button type="submit" class="btn app-btn-best" id="btn-modal-adicionar">Adicionar</button>
        </div>
      </form>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/voucher/voucher-resgatar/voucher-resgatar.component.html